import './blocks/business-oriented';
import './blocks/competitive-edge';
import './blocks/careers-slider';
import './blocks/contact';
import './blocks/how-it-works';
import './blocks/leadership';
import './blocks/news';
import './blocks/results';
import './blocks/latest-news';
import './blocks/header-text-images';
import './blocks/header-text-overlapping-image';
import './blocks/technology-slider';
import './blocks/solution';
import './blocks/hero';
import './blocks/tabs-with-content';
import './blocks/apply-form';
import './blocks/locations';
import './blocks/video-with-text';
import './blocks/powered-binah-slider';
import './blocks/timeline';
import './blocks/faq';
import './blocks/latest-news-sharp';
import './blocks/image-video-text';
import './blocks/testimonials-carousel';
import './blocks/logos-slider';
import './blocks/anchor-nav';
import './blocks/table-text';
import './blocks/contact-side';
import './blocks/employees-carousel';
import './blocks/greenhouse-careers';
import './blocks/contact-side';
import './blocks/tabs-vertical';
import './blocks/science-carousel';
import './blocks/how-it-works-new';
import './blocks/technology-new-insights';
import './blocks/technology-new-accordion';
import './blocks/gallery';


// WEBPACK FOOTER //
// ./scripts/blocks.js